import { ComponentProps, FunctionComponent } from 'react'
import { WIcon, WTooltip } from '@alice-health/wonderland-react'
import classNames from 'classnames'
import { MAP_PRIVACY_NOTICE_TEXT } from './MapPrivacyNotice.constants'

interface MapPrivacyNoticeProps {
  className?: string
  position?: ComponentProps<typeof WTooltip>['position']
}

// The tooltip opens on hover only, so the label also goes on the wrapper for
// screen readers.
const MapPrivacyNotice: FunctionComponent<MapPrivacyNoticeProps> = ({
  className,
  position = 'top'
}) => (
  <WTooltip
    label={MAP_PRIVACY_NOTICE_TEXT}
    position={position}
  >
    <span
      role='img'
      aria-label={MAP_PRIVACY_NOTICE_TEXT}
      className={classNames(
        'flex items-center text-sys-color-content-tertiary',
        className
      )}
    >
      <WIcon
        icon='icInfo'
        size='medium'
      />
    </span>
  </WTooltip>
)

export { MapPrivacyNotice }
export type { MapPrivacyNoticeProps }
